export const colorBrandAttblue = { value: '#009fdb' };
export const colorBrandCobalt = { value: '#0057b8' };
export const colorBrandBerry = { value: '#ff585d' };
export const colorBrandLime = { value: '#91dc00' };
export const colorBrandMint = { value: '#49eedc' };
export const colorBrandPurple = { value: '#af29bb' };
export const colorBrandTangerine = { value: '#ffb000' };
export const colorAttblue100 = { value: '#dcf3fa' };
export const colorAttblue200 = { value: '#baeefc' };
export const colorAttblue000 = { value: '#f2fafd' };
export const colorCobalt100 = { value: '#e5eef8' };
export const colorCobalt400 = { value: '#007ae2' };
export const colorCobalt600 = { value: '#0057b8' };
export const colorCobalt800 = { value: '#25303a' };
export const colorWhite = { value: '#ffffff' };
export const colorBlack = { value: '#000000' };
export const colorTransparent = { value: 'rgba(0, 0, 0, 0)' };
export const colorGray100 = { value: '#f8fafb' };
export const colorGray200 = { value: '#f3f4f6' };
export const colorGray300 = { value: '#dcdfe3' };
export const colorGray400 = { value: '#bdc2c7' };
export const colorGray500 = { value: '#878c94' };
export const colorGray600 = { value: '#686e74' };
export const colorGray700 = { value: '#454b52' };
export const colorGray800 = { value: '#1d2329' };
export const colorGray900 = { value: '#13171b' };
export const colorFuncGreen400 = { value: '#3da930' };
export const colorFuncGreen600 = { value: '#2d7e24' };
export const colorFuncOrange400 = { value: '#ff8500' };
export const colorFuncOrange600 = { value: '#ea712f' };
export const colorFuncRed400 = { value: '#ff4349' };
export const colorFuncRed600 = { value: '#c70032' };
export const colorFuncBlue400 = { value: '#007ae2' };
export const colorFuncBlue600 = { value: '#0057b8' };
export const colorPartnerHBOMax = { value: '#4511a5' };
export const scrimLight = { value: 'rgba(255, 255, 255, 0.85)' };
export const scrimDark = { value: 'rgba(0, 0, 0, 0.85)' };
export const buttonLGFontSize = { value: '1.4rem' };
export const buttonSMFontSize = { value: '1.2rem' };
export const buttonFontFamily = { value: 'font-bold, sans-serif' };
export const buttonDisabledBgColor = { value: '#dcdfe3' };
export const buttonDisabledBorderColor = { value: '#dcdfe3' };
export const buttonDisabledTextColor = { value: '#686e74' };
export const buttonPrimaryBgColor = { value: '#1d2329' };
export const buttonPrimaryBorderColor = { value: '#1d2329' };
export const buttonPrimaryTextColor = { value: '#ffffff' };
export const buttonPrimaryHoverBgColor = { value: '#454b52' };
export const buttonPrimaryHoverBorderColor = { value: '#454b52' };
export const buttonPrimaryHoverTextColor = { value: '#ffffff' };
export const buttonPrimary2TextColor = { value: '#ffffff' };
export const buttonPrimary2HoverBgColor = { value: '#007ae2' };
export const buttonPrimary2HoverBorderColor = { value: '#007ae2' };
export const buttonPrimary2HoverTextColor = { value: '#ffffff' };
export const buttonPrimary2BgColor = { value: '#0057b8' };
export const buttonPrimary2BorderColor = { value: '#0057b8' };
export const buttonSecondaryBgColor = { value: 'rgba(0, 0, 0, 0)' };
export const buttonSecondaryBorderColor = { value: '#1d2329' };
export const buttonSecondaryTextColor = { value: '#1d2329' };
export const buttonSecondaryHoverBgColor = { value: '#454b52' };
export const buttonSecondaryHoverBorderColor = { value: '#454b52' };
export const buttonSecondaryHoverTextColor = { value: '#ffffff' };
export const eyebrowLineHeight = { value: '01.15' };
export const eyebrowCase = { value: 'uppercase' };
export const eyebrowXXXLFontSizeMobile = { value: '2.4rem' };
export const eyebrowXXXLFontSizeTablet = { value: '2.6rem' };
export const eyebrowXXXLFontSizeDesktop = { value: '2.8rem' };
export const eyebrowXXLFontSizeMobile = { value: '2.2rem' };
export const eyebrowXXLFontSizeTablet = { value: '2.4rem' };
export const eyebrowXXLFontSizeDesktop = { value: '2.6rem' };
export const eyebrowXLFontSizeMobile = { value: '2.0rem' };
export const eyebrowXLFontSizeTablet = { value: '2.2rem' };
export const eyebrowXLFontSizeDesktop = { value: '2.4rem' };
export const eyebrowLGFontSizeMobile = { value: '1.6rem' };
export const eyebrowLGFontSizeTablet = { value: '1.8rem' };
export const eyebrowLGFontSizeDesktop = { value: '2.0rem' };
export const eyebrowMDFontSizeMobile = { value: '1.4rem' };
export const eyebrowMDFontSizeTablet = { value: '1.6rem' };
export const eyebrowMDFontSizeDesktop = { value: '1.6rem' };
export const eyebrowFontFamily = { value: 'font-regular, sans-serif' };
export const eyebrowTextColor = { value: '#1d2329' };
export const headingLineHeight = { value: '01.15' };
export const headingLetterSpacing = { value: '-0.03em' };
export const headingXXXLFontSizeMobile = { value: '3.6rem' };
export const headingXXXLFontSizeTablet = { value: '4.2rem' };
export const headingXXXLFontSizeDesktop = { value: '6.0rem' };
export const headingXXLFontSizeMobile = { value: '3.2rem' };
export const headingXXLFontSizeTablet = { value: '3.8rem' };
export const headingXXLFontSizeDesktop = { value: '4.8rem' };
export const headingXLFontSizeMobile = { value: '2.8rem' };
export const headingXLFontSizeTablet = { value: '3.4rem' };
export const headingXLFontSizeDesktop = { value: '4.2rem' };
export const headingLGFontSizeMobile = { value: '2.4rem' };
export const headingLGFontSizeTablet = { value: '2.8rem' };
export const headingLGFontSizeDesktop = { value: '3.4rem' };
export const headingMDFontSizeMobile = { value: '2.0rem' };
export const headingMDFontSizeTablet = { value: '2.2rem' };
export const headingMDFontSizeDesktop = { value: '2.6rem' };
export const headingSMFontSizeMobile = { value: '1.6rem' };
export const headingSMFontSizeTablet = { value: '1.8rem' };
export const headingSMFontSizeDesktop = { value: '2.0rem' };
export const headingXSFontSizeMobile = { value: '1.2rem' };
export const headingXSFontSizeTablet = { value: '1.4rem' };
export const headingXSFontSizeDesktop = { value: '1.6rem' };
export const headingFontFamily = { value: 'font-bold, sans-serif' };
export const headingTextColor = { value: '#1d2329' };
export const mediaQueryMobileMaxWidth = { value: '0767' };
export const mediaQueryTabletMinWidth = { value: '0768' };
export const mediaQueryTabletMaxWidth = { value: '01024' };
export const mediaQueryDesktopMinWidth = { value: '01025' };
export const borderRadius100 = { value: '100%' };
export const borderRadiusLG = { value: '1.6rem' };
export const borderRadiusMD = { value: '0.8rem' };
export const borderRadiusSM = { value: '0.4rem' };
export const borderRadiusPill = { value: '2em' };
export const fontFamilyRegular = { value: 'font-regular, sans-serif' };
export const fontFamilyBold = { value: 'font-bold, sans-serif' };
export const lineHeight0 = { value: '00' };
export const lineHeightLG = { value: '01.6' };
export const lineHeightMD = { value: '01.4' };
export const lineHeightBASE = { value: '01.2' };
export const lineHeightSM = { value: '01' };
export const lineHeightXS = { value: '00.8' };
export const lineHeightLoose = { value: '01.6' };
export const lineHeightNormal = { value: '01.4' };
export const lineHeightTight = { value: '01.2' };
export const lineHeightReset = { value: '01' };
export const type10 = { value: '1.0rem' };
export const type11 = { value: '1.1rem' };
export const type12 = { value: '1.2rem' };
export const type13 = { value: '1.3rem' };
export const type14 = { value: '1.4rem' };
export const type15 = { value: '1.5rem' };
export const type16 = { value: '1.6rem' };
export const type18 = { value: '1.8rem' };
export const type20 = { value: '2.0rem' };
export const type22 = { value: '2.2rem' };
export const type24 = { value: '2.4rem' };
export const type26 = { value: '2.6rem' };
export const type34 = { value: '3.4rem' };
export const type42 = { value: '4.2rem' };
export const type48 = { value: '4.8rem' };
export const type60 = { value: '6.0rem' };
export const typeLGMobile = { value: '1.8rem' };
export const typeLGTablet = { value: '2.0rem' };
export const typeLGDesktop = { value: '2.4rem' };
export const typeBASEMobile = { value: '1.6rem' };
export const typeBASETablet = { value: '1.7rem' };
export const typeBASEDesktop = { value: '1.8rem' };
export const typeSMMobile = { value: '1.4rem' };
export const typeSMTablet = { value: '1.5rem' };
export const typeSMDesktop = { value: '1.5rem' };
export const typeXSMobile = { value: '1.1rem' };
export const typeXSTablet = { value: '1.2rem' };
export const typeXSDesktop = { value: '1.2rem' };
export const typeXXSMobile = { value: '1.0rem' };
export const typeXXSTablet = { value: '1.0rem' };
export const typeXXSDesktop = { value: '1.1rem' };
export const typeBodyRoot = { value: '62.5%' };
export const typeLegalFontSizeMobile = { value: '1.1rem' };
export const typeLegalFontSizeTablet = { value: '1.2rem' };
export const typeLegalFontSizeDesktop = { value: '1.2rem' };
export const calendarBorderRadius = { value: '0.8rem' };
export const cardBorderRadius = { value: '1.6rem' };
export const checkboxBorderRadius = { value: '0.4rem' };
export const checkboxBorderColor = { value: '#686e74' };
export const checkboxBgColor = { value: '#ffffff' };
export const checkboxDisabledBgColor = { value: '#f8fafb' };
export const checkboxDisabledBorderColor = { value: '#bdc2c7' };
export const checkboxDisabledLabelTextColor = { value: '#878c94' };
export const checkboxErrorBgColor = { value: '#c70032' };
export const checkboxErrorLabelTextColor = { value: '#454b52' };
export const checkboxErrorBorderColor = { value: '#c70032' };
export const checkboxLabelFontFamily = { value: 'font-regular, sans-serif' };
export const checkboxLabelFontSize = { value: '1.4rem' };
export const checkboxLabelTextColor = { value: '#454b52' };
export const checkboxSelectedBgColor = { value: '#0057b8' };
export const checkboxSelectedBorderColor = { value: '#0057b8' };
export const checkboxFocusOutlineColor = { value: '#000000' };
export const focusOutlineColor = { value: '#000000' };
export const dropdownFontFamily = { value: 'font-regular, sans-serif' };
export const dropdownFontSize = { value: '1.6rem' };
export const dropdownBorderRadius = { value: '0.8rem' };
export const dropdownBorderColor = { value: '#686e74' };
export const dropdownHoverBorderColor = { value: '#0057b8' };
export const dropdownPlaceholderTextColor = { value: '#686e74' };
export const dropdownPlaceholderFontSize = { value: '1.6rem' };
export const dropdownSelectedValTextColor = { value: '#1d2329' };
export const dropdownErrorBorderColor = { value: '#c70032' };
export const dropdownOptionFontFamily = { value: 'font-regular, sans-serif' };
export const dropdownOptionFontSize = { value: '1.4rem' };
export const dropdownOptionHoverBgColor = { value: '#e5eef8' };
export const dropdownOptionHoverTextColor = { value: '#0057b8' };
export const dropdownOptionSelectedBgColor = { value: '#f8fafb' };
export const dropdownOptionSelectedTextColor = { value: '#454b52' };
export const dropdownOptionSelectedHoverTextColor = { value: '#0057b8' };
export const dropdownOptionTextColor = { value: '#454b52' };
export const dropdownOptgroupFontFamily = { value: 'font-bold, sans-serif' };
export const dropdownOptgroupFontSize = { value: '1.4rem' };
export const dropdownFocusOutlineColor = { value: '#000000' };
export const dropdownDisabledValTextColor = { value: '#878c94' };
export const formLabelFontFamily = { value: 'font-bold, sans-serif' };
export const formLabelFontSize = { value: '1.4rem' };
export const formLabelTextColor = { value: '#1d2329' };
export const formLabelErrorDotColor = { value: '#c70032' };
export const formLabelDisabledTextColor = { value: '#878c94' };
export const formDisabledTextColor = { value: '#878c94' };
export const formDefaultTextColor = { value: '#454b52' };
export const formBorderColor = { value: '#686e74' };
export const formErrorBorderColor = { value: '#c70032' };
export const radioCheckboxLabelFontFamily = { value: 'font-regular, sans-serif' };
export const radioCheckboxKeyboardFocusOutlineColor = { value: '#000000' };
export const radioBorderRadius = { value: '100%' };
export const radioBorderColor = { value: '#686e74' };
export const radioBgColor = { value: '#ffffff' };
export const radioDisabledBgColor = { value: '#878c94' };
export const radioDisabledBorderColor = { value: '#878c94' };
export const radioDisabledLabelTextColor = { value: '#878c94' };
export const radioErrorBgColor = { value: '#c70032' };
export const radioErrorBorderColor = { value: '#c70032' };
export const radioErrorLabelTextColor = { value: '#454b52' };
export const radioLabelFontFamily = { value: 'font-regular, sans-serif' };
export const radioLabelFontSize = { value: '1.4rem' };
export const radioLabelTextColor = { value: '#454b52' };
export const radioSelectedBgColor = { value: '#0057b8' };
export const radioSelectedBorderColor = { value: '#0057b8' };
export const radioFocusOutlineColor = { value: '#000000' };
export const formfieldBorderRadius = { value: '0.8rem' };
export const formfieldBorderColor = { value: '#686e74' };
export const formfieldErrorBorderColor = { value: '#c70032' };
export const formfieldHoverBorderColor = { value: '#0057b8' };
export const formfieldPlaceholderTextColor = { value: '#686e74' };
export const formfieldTextColor = { value: '#1d2329' };
export const formfieldBgColor = { value: '#ffffff' };
export const formfieldDisabledBgColor = { value: '#f8fafb' };
export const formfieldDisabledBorderColor = { value: '#bdc2c7' };
export const formfieldDisabledTextColor = { value: '#878c94' };
export const formfieldFocusBorderColor = { value: '#0057b8' };
export const notificationTimedBorderRadius = { value: '0.8rem' };
export const tabsSelectedBorderRadius = { value: '0.4rem' };
export const tagsBorderRadius = { value: '0.4rem' };
export const usageMeterBorderRadius = { value: '2em' };
